import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { FormattedMessage } from 'react-intl';

import { GUIDANCE_CONTROL_PERSISTENCE } from 'yeself-common/typings/application/ApplicationEnum';

type PersistenceValue = typeof GUIDANCE_CONTROL_PERSISTENCE[keyof typeof GUIDANCE_CONTROL_PERSISTENCE];

type GuidanceControlPersistenceProps = {
    onChange: (value: PersistenceValue) => void;
    value: PersistenceValue;
    classNames: {
        itemTextClassName?: string;
        textField?: string;
        cssSelectRoot?: string;
        cssUnderline?: string;
        menu?: string;
        formInput?: string;
    };
};

const GuidanceControlPersistence = ({
    onChange,
    value,
    classNames = {},
}: GuidanceControlPersistenceProps): React.ReactElement => (
    <Grid container alignItems="center" style={{ paddingBottom: '20px' }}>
        <Typography variant="subtitle1" className={classNames.itemTextClassName}>
            <FormattedMessage
                id="ContextHelp.guidanceControl.persistence.title"
                defaultMessage="Browser persistence"
            />
        </Typography>
        <Grid id="yeself-guidance-control-dropdown" item className={classNames.formInput}>
            <TextField
                value={value}
                onChange={(event) => onChange(event.target.value as PersistenceValue)}
                select
                fullWidth={false}
                className={classNames.textField}
                margin="normal"
                variant="filled"
                InputProps={{
                    classes: {
                        root: classNames.cssSelectRoot,
                        underline: classNames.cssUnderline,
                    },
                }}
                SelectProps={{
                    MenuProps: {
                        className: classNames.menu,
                    },
                }}
            >
                {Object.values(GUIDANCE_CONTROL_PERSISTENCE).map((option) => (
                    <MenuItem value={option} key={option}>
                        <FormattedMessage
                            id={`ContextHelp.guidanceControl.persistence.options.${option}`}
                        />
                    </MenuItem>
                ))}
            </TextField>
        </Grid>
    </Grid>
);

export default GuidanceControlPersistence;
